/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $S3GetObjectUrl = {
  properties: {
    url: {
      type: 'string',
      description: `s3 get object url`,
      isRequired: true,
    },
  },
} as const;
